import type {RouteRecordRaw} from "vue-router";
import MedicationCheckupLayout from "@/medication-checkup/layouts/MedicationCheckupLayout.vue";
import MedicationCheckupCycleView from "@/medication-checkup/views/MedicationCheckupCycleView.vue";

/**
 * Routes of the BPM Copilote.
 *
 * The course is addressed by consumer key, as every patient screen of Connect
 * is; the cycle it opens on is resolved from the bilan, so a bookmarked URL
 * still lands on the cycle in progress.
 */
export const MedicationCheckupRouter: RouteRecordRaw[] = [
    {
        path: '/medication-checkup/:consumerKey',
        component: MedicationCheckupLayout,
        props: true,
        meta: {
            layout: 'TheBlankLayout'
        },
        children: [
            {
                path: '',
                name: 'medication-checkup.cycle',
                component: MedicationCheckupCycleView
            }
        ]
    }
];
